import type { CalculatedPriceRangeFragment } from './RegistryGiftCounts.graphql.generated';

export const ZERO_STATE_PRICE_RANGES: CalculatedPriceRangeFragment[] = [
  {
    targetGiftCount: 0,
    currentGiftCount: 0,
    startPrice: {
      currency: {
        code: 'USD',
        places: 2,
        __typename: 'Currency',
      },
      valueInMinorUnits: 0,
      floatingPointDecimalString: '0.00',
      __typename: 'MonetaryValue',
    },
    endPrice: {
      currency: {
        code: 'USD',
        places: 2,
        __typename: 'Currency',
      },
      valueInMinorUnits: 5000,
      floatingPointDecimalString: '50.00',
      __typename: 'MonetaryValue',
    },
    __typename: 'CalculatedPriceRange',
  },
  {
    targetGiftCount: 0,
    currentGiftCount: 0,
    startPrice: {
      currency: {
        code: 'USD',
        places: 2,
        __typename: 'Currency',
      },
      valueInMinorUnits: 5000,
      floatingPointDecimalString: '50.00',
      __typename: 'MonetaryValue',
    },
    endPrice: {
      currency: {
        code: 'USD',
        places: 2,
        __typename: 'Currency',
      },
      valueInMinorUnits: 10000,
      floatingPointDecimalString: '100.00',
      __typename: 'MonetaryValue',
    },
    __typename: 'CalculatedPriceRange',
  },
  {
    targetGiftCount: 0,
    currentGiftCount: 0,
    startPrice: {
      currency: {
        code: 'USD',
        places: 2,
        __typename: 'Currency',
      },
      valueInMinorUnits: 10000,
      floatingPointDecimalString: '100.00',
      __typename: 'MonetaryValue',
    },
    endPrice: {
      currency: {
        code: 'USD',
        places: 2,
        __typename: 'Currency',
      },
      valueInMinorUnits: 15000,
      floatingPointDecimalString: '150.00',
      __typename: 'MonetaryValue',
    },
    __typename: 'CalculatedPriceRange',
  },
  {
    targetGiftCount: 0,
    currentGiftCount: 0,
    startPrice: {
      currency: {
        code: 'USD',
        places: 2,
        __typename: 'Currency',
      },
      valueInMinorUnits: 15000,
      floatingPointDecimalString: '150.00',
      __typename: 'MonetaryValue',
    },
    endPrice: null,
    __typename: 'CalculatedPriceRange',
  },
];

export const GRADIENT_PRESETS = {
  TEAL: {
    startColor: {
      hex: '#189289',
      p3: 'color(display-p3 0.0941 0.5725 0.5373)',
    },
    endColor: {
      hex: '#00BAAC',
      p3: 'color(display-p3 0.0000 0.7298 0.6760)',
    },
  },
};
